const Index = () => {
  return (
    <div>
      <h1>Become The Life Struggler!</h1>
    </div>
  )
}

export default Index
